const MuiButton = {
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
  },
}

export default MuiButton
